import { gql } from '@apollo/client';

export const ASSIGN_SECTION_DOCUMENTS = gql`
  mutation AssignSectionDocuments($params: AssignSectionDocumentInput!) {
    assignSectionDocuments(params: $params) {
      success
      message
      errors
    }
  }
`;

export const ASSIGN_SECTION_SCHEMAS = gql`
  mutation AssignSectionSchemas($params: AssignSectionSchemaInput!) {
    assignSectionSchemas(params: $params) {
      success
      message
      errors
    }
  }
`;

export const ASSIGN_SECTION_NODES = gql`
  mutation AssignSectionNodes($params: AssignSectionNodeInput!) {
    assignSectionNodes(params: $params) {
      success
      message
      errors
    }
  }
`;
